import React, { useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import SideMenu, { CLINIC_URL_TYPE } from "./SideMenu";
import DoctorDashboardNew from "../../DoctorDashboard/index";

import DoctorMyPatients from "../../DoctorComponents/DoctorMyPatients/index";
import PrescriptionsDoctor from "../../PrescriptionsDoctor";
import KnowledgeCenter from "../../Knowledge Center/index";
import Reward from "../../DoctorCoupon/reward";
import MessagesContainer from "../../../Containers/MessagesContainer";

import MedUpdates from "../../DoctorMedshots/NewMedUpdatesRedirectPage";
import Settings from "../../Settings";

import "../../DoctorDashboard/component-styles.scss";
import { appID, appleAppID } from "../../../Util/API Calls/oneSignalMap";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";

import MyScheduleFees from "../../DoctorComponents/MyScheduleFees/index";
import DoctorWebinar from "../../WebinarNew";
import WebinarKnowMoreDetails from "../../WebinarNew/knowmoreDeatils";
import StaffDashboard from "../../Staff/StaffDashboard";
import StaffSettingsWrapper from "../../Staff/StaffSettings";
import { DoctorContextProvider } from "../../ClinicComponents/ClinicWrapper/DoctorContext";
import MyTransactionsView from "../../MyTransactionsView";
import MyPatientsViewAppointmnets from "../../MyPatientsViewAppointments";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { USER_TYPE } from "../../../Util/constants";
import RaiseInvoice from "../../RaiseInvoice";

const DoctorDashboardLayout = (props) => {
  const { match } = props;
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);

  window.OneSignal = window.OneSignal || [];
  let OneSignal = window.OneSignal;
  useEffect(() => {
    OneSignal.push(() => {
      OneSignal.init({
        appId: appID,
        safari_web_id: appleAppID,
        allowLocalhostAsSecureOrigin: true,
        promptOptions: {
          slidedown: {
            enabled: true,
            actionMessage:
              "We'd like to send you notifications for the latest news and updates.",
            acceptButtonText: "Allow",
            cancelButtonText: "No",
          },
        },
        welcomeNotification: {
          title: "Welcome to C2C!",
          message: "Start consultation with your patient right now!",
        },
      });
    });

    OneSignal.push(function () {
      OneSignal.on("subscriptionChange", function (isSubscribed) {
        OneSignal.getUserId().then(function (device_id) {
          afterLoginApiAxios({
            method: "post",
            url: "public/register-push-notification",
            headers: {
              authorization: localStorage.getItem("id_token"),
            },
            data: {
              user_id: userType === USER_TYPE.STAFF ? staffId : userId,
              user_type: userType,
              device_id: device_id,
              device_type: "web",
            },
          });
        });
      });
    });
    OneSignal.push(() => {
      OneSignal.on("notificationDisplay", (event) => {
        foregroundWillDisplayListener(event);
      });
    });
  }, []);

  const foregroundWillDisplayListener = (notification) => {
    console.log(`notification will display: ${notification}`);
  };

  // this array contains detail for routes
  const routesDetails = [
    {
      path: "dashboard",
      renderTo:
        userType === "staff" &&
        localStorage.getItem(LOCALSTORAGEKEY.STAFF_CLINIC_ASSOCIATION) ===
          "false"
          ? StaffDashboard
          : DoctorDashboardNew,
    },
    {
      path: "mypatients/prescription/:id",
      renderTo: PrescriptionsDoctor,
    },
    {
      path: "mypatients/:id",
      renderTo: MyPatientsViewAppointmnets,
    },

    {
      path: "mypatients",
      renderTo: DoctorMyPatients,
    },
    { path: "patienteducation", renderTo: KnowledgeCenter },
    { path: "medupdates", renderTo: MedUpdates },
    { path: "rewards", renderTo: Reward },
    { path: "messages", renderTo: MessagesContainer },
    {
      path: "mytransactions",
      renderTo: MyTransactionsView,
    },
    { path: "myschedulefees2", renderTo: MyScheduleFees },
    {
      path: "settings",
      renderTo: userType === "staff" ? StaffSettingsWrapper : Settings,
    },

    { path: "help", renderTo: Settings },
    { path: "webinars", renderTo: DoctorWebinar },
    { path: "webinars/know-more/:id", renderTo: WebinarKnowMoreDetails },
    { path: "raise-invoice", renderTo: RaiseInvoice },
  ];
  // creating routes by this function

  const renderRoutes = routesDetails.map((routeDetail, index) => {
    return (
      <Route
        key={index}
        exact
        path={`${match.path}/${routeDetail.path}`}
        render={(props) => <routeDetail.renderTo {...props} key={index} />}
      />
    );
  });

  const rightUI = () => {
    return (
      <div
        className="col-12 px-0"
        style={{ overflowY: "auto", maxHeight: "100vh" }}
      >
        <Switch>
          {renderRoutes}

          <Route
            render={() => {
              return <Redirect to="/" />;
            }}
          />
        </Switch>
      </div>
    );
  };

  // rendering
  return (
    <DoctorContextProvider>
      <div className="container-fluid p-0">
        <div className="row m-0">
          <SideMenu
            user_type={userType}
            clinic_url_type={CLINIC_URL_TYPE.DOCTOR}
            rightUI={rightUI}
          />
        </div>
      </div>
    </DoctorContextProvider>
  );
};

export default DoctorDashboardLayout;
